<template>
  <div id="create-order" class="create-order">
    <b-modal
      ref="confirmModal"
      :size="modalSize"
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
      hide-footer
      :static="true"
      :title="title">
      <b-form novalidate class="order-form" @submit.prevent="confirm">
        <b-container>
          <b-row v-if="splitLoadsAllowed">
            <b-col>
              <b-form-checkbox
                v-model="splitLoad"
                name="split-load-toggle"
                switch
                @change="splitLoadToggled">
                Split Load Order
              </b-form-checkbox>
            </b-col>
          </b-row>
          <span v-for="(load,index) in parseInt(splitLoadCount)" :key="index">
          <b-row>
            <b-col cols="8" col>
              <b>Site:</b> <span :id="`site-load-name-${load}`">{{ loads[index].siteDisplay }}</span>
            </b-col>
            <b-col v-if="loads[index].confirmErrors.length > 0" class="float-right">
              <b-dropdown
                v-if="loads[index].confirmErrors.length > 0"
                :id="`split-load-error-btn-${load}`"
                size="sm"
                variant="outline-danger"
                text="Fix Errors"
                right
                class="mb-2"
              >
                <b-dropdown-item v-for="(msg,index) in loads[index].confirmErrors" :key="`errmsg-${index}`"><strong>{{ `${index+1}) ` }}</strong>{{ msg }}</b-dropdown-item>
              </b-dropdown>
            </b-col>
            <b-col v-if="splitLoad && load > 1" class="text-right pl-0">
             <b-button
               :id="`split-load-remove-btn-${load}`"
               :aria-label="`Remove Split Load ${load}`"
               variant="kag-red"
               size="sm"
               @click="removeSplitLoad(index)"
               >Remove</b-button>
            </b-col>
            <b-col cols="12" col>
              <table class="table b-table table-bordered table-sm b-table-no-border-collapse mb-0">
                <thead>
                  <tr>
                    <th>
                      Retain Date
                    </th>
                    <th>
                      Retain Time
                    </th>
                    <th>
                      Runout Date
                    </th>
                    <th>
                      Runout Time
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <b-input-group>
                        <b-form-input
                          id="order-retain-date"
                          v-model="loads[index].retainDateString"
                          type="text"
                          size="sm"
                          placeholder="MM/DD/YY"
                          autocomplete="off"
                          maxlength="8"
                          :state="retainDateState(index)"
                          @input="onRetainDateChange($event, index)"
                          @keydown="handleRetainDateKeyDown($event, index)"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-form-datepicker
                            button-only
                            left
                            id="order-retain-date-icon"
                            size="sm"
                            value-as-date
                            hide-header
                            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                            locale="en"
                            v-model="loads[index].order.retainDate"
                            @context="onRetainDateContext($event, index)"
                          ></b-form-datepicker>
                        </b-input-group-append>
                      </b-input-group>
                    </td>
                    <td>
                      <b-input-group>
                        <b-form-input
                          id="order-retain-time"
                          v-model="loads[index].retainTimeString"
                          type="text"
                          size="sm"
                          placeholder="HH:MM"
                          autocomplete="off"
                          maxlength="5"
                          :state="retainTimeState(index)"
                          @input="onRetainTimeChange($event, index)"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-form-timepicker
                            button-only
                            left
                            id="order-retain-time-icon"
                            size="sm"
                            hide-header
                            no-close-button
                            locale="en-US-u-hc-h23"
                            :hour12="false"
                            v-model="loads[index].order.retainTime"
                            @context="onRetainTimeContext($event, index)"
                          ></b-form-timepicker>
                        </b-input-group-append>
                      </b-input-group>
                    </td>
                    <td>
                      <b-input-group>
                        <b-form-input
                          id="order-runout-date"
                          v-model="loads[index].runoutDateString"
                          type="text"
                          size="sm"
                          placeholder="MM/DD/YY"
                          autocomplete="off"
                          maxlength="8"
                          :state="runoutDateState(index)"
                          @input="onRunoutDateChange($event, index)"
                          @keydown="handleRunoutDateKeyDown($event, index)"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-form-datepicker
                            button-only
                            left
                            id="order-runout-date-icon"
                            size="sm"
                            value-as-date
                            hide-header
                            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                            locale="en"
                            v-model="loads[index].order.runoutDate"
                            @context="onRunoutDateContext($event, index)"
                          ></b-form-datepicker>
                        </b-input-group-append>
                      </b-input-group>
                    </td>
                    <td>
                      <b-input-group>
                        <b-form-input
                          id="order-runout-time"
                          v-model="loads[index].runoutTimeString"
                          type="text"
                          size="sm"
                          placeholder="HH:MM"
                          autocomplete="off"
                          maxlength="5"
                          :state="runoutTimeState(index)"
                          @input="onRunoutTimeChange($event, index)"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-form-timepicker
                            button-only
                            left
                            id="order-runout-time-icon"
                            size="sm"
                            hide-header
                            no-close-button
                            locale="en-US-u-hc-h23"
                            :hour12="false"
                            v-model="loads[index].order.runoutTime"
                            @context="onRunoutTimeContext($event, index)"
                          ></b-form-timepicker>
                        </b-input-group-append>
                      </b-input-group>
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" col>
              <table class="table b-table table-responsive table-bordered table-sm b-table-no-border-collapse mb-0">
                <thead>
                  <tr>
                    <th>
                      Product
                    </th>
                    <th v-for="tank in loads[index].tankOrders" :key="tank.commodityClass">
                      {{ tank.commodityClass }}
                      <div>{{ tank.commodityCode }}</div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td >
                      Gallons
                    </td>
                    <td v-for="tank in loads[index].tankOrders" :key="tank.commodityClass">
                      <b-form-group
                        :id="'tankGallons-fieldset' + tank.id"
                        class="tankGallons-form-group mb-0"
                        v-bind:class="{ 'warn': !!gallonsWarnState(tank) }"
                      >
                        <b-form-input
                          :id="'order-' + tank.commodityClass"
                          class="order-input tankGallons-input"
                          size="sm"
                          v-model="tank.gallons"
                          type="number"
                          :max="tank.safefillQty"
                          min="0"
                          :disabled="tank.outOfService"
                          :class="{'oos-disabled': tank.outOfService }"
                        ></b-form-input>
                        <font-awesome-icon
                          class="tankGallons-icon"
                          icon="circle-info"
                          v-if="!!gallonsWarnState(tank)"
                          v-b-tooltip.hover="gallonsTooltipState(tank)"
                        />
                      </b-form-group>
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-col>
          </b-row>
        </span>
        <b-row v-if="splitLoad && splitLoadCount < maxNumberOfSplitLoads">
          <b-col>
            <SiteAutocomplete
              ref="site_autocomplete"
              :sitesToDisplay="sitesForSplitLoads"
              @siteSelected="splitLoadSiteSelected"
              @inputCleared="onSiteAutocompleteCleared" />
          </b-col>
        </b-row>
        <b-row v-if="splitLoad && splitLoadCount < maxNumberOfSplitLoads">
            <b-col class="text-center">
             <b-button
               id="split-load-add-btn"
               :variant="addSplitLoadBtnColor"
               @click="addSplitLoad"
               :disabled="disableAddSplitLoadBtn">{{
               addSplitLoadBtnText
               }}</b-button>
            </b-col>
        </b-row>
          <b-row v-if="loads.length > 0">
            <b-col cols="12" col>
              <table class="table b-table table-bordered table-sm b-table-no-border-collapse">
                <thead>
                  <tr>
                    <th>
                      Customer Shift
                    </th>
                    <th>
                      Release Number
                    </th>
                    <th>
                      Order Remarks
                    </th>
                    <th v-if="allowPONumber">
                      PO Number
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <b-input-group>
                        <b-form-input
                          id="customer-shift-number"
                          v-model="loads[0].order.customerShift"
                          type="text"
                          size="sm"
                          autocomplete="off"
                          maxlength="30"
                        ></b-form-input>
                      </b-input-group>
                    </td>
                    <td>
                      <b-input-group>
                        <b-form-input
                          id="release-number"
                          v-model="loads[0].order.releaseNumber"
                          type="text"
                          size="sm"
                          autocomplete="off"
                          maxlength="30"
                        ></b-form-input>
                      </b-input-group>
                    </td>
                    <td>
                      <b-input-group>
                        <b-form-input
                          id="order-remarks"
                          v-model="loads[0].order.orderRemarks"
                          type="text"
                          size="sm"
                          autocomplete="off"
                          maxlength="200"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button class="btn-secondary" variant="kag-light-gray" size="sm" @click="openOrderRemarksPopUp()">
                            <font-awesome-icon  icon="pen-to-square" />
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </td>
                    <td v-if="allowPONumber">
                      <b-input-group>
                        <b-form-input
                          id="po-number"
                          v-model="loads[0].order.poNumber"
                          type="text"
                          size="sm"
                          autocomplete="off"
                          maxlength="30"
                        ></b-form-input>
                      </b-input-group>
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-col>
          </b-row>
          <b-row v-if="loads.length > 0">
            <b-col cols="4" col>
              <table class="table b-table table-bordered table-sm b-table-no-border-collapse">
                <thead>
                  <tr>
                    <th>
                      Order Priority
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <b-form-select id="order-priority" v-model="loads[0].order.priority" :options="priorityOptions" :select-size="2"></b-form-select>
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" col offset-lg="4" lg="4" class="pt-2 pb-2">
              <div class="d-flex">
                <b-button class="mt-2 mr-3" block variant="outline-kag-dark-blue" type="submit">Save</b-button>
                <b-button id="confirm-modal-cancel-btn" block variant="outline-kag-red" @click="cancel">Cancel</b-button>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </b-form>
    </b-modal>
    <OrderRemarks ref="orderRemarksModal" @confirmedValue="receiveOrderRemarks"/>
    <ConfirmModal ref="removeStopConfirmModal"></ConfirmModal>
  </div>
</template>

<style lang="scss">
.tankGallons-form-group {
  &.warn {
   .tankGallons-input {
     display: inline-block;
     width: calc(100% - 30px);
     margin-right: 5px;
   }
  .tankGallons-icon {
    display: inline-block;
    color: $kag-warning-color;
   }
  }
}

</style>

<script>
import moment from 'moment-timezone'

import global from '@/mixins/shared/global'
import userAuthGetters from '@/mixins/shared/userAuthGetters'
import toastMixin from '@/mixins/shared/toastMixin'

import { RepositoryFactory } from '@/repositories/RepositoryFactory'
import OrderRemarks from '@/components/shared/modal/OrderRemarks.vue'
import SiteAutocomplete from '@/components/site/SiteAutocomplete.vue'
import ConfirmModal from '@/components/shared/ConfirmModal.vue'
const TankRepo = RepositoryFactory.get('TankRepository')
const FimOrderRepo = RepositoryFactory.get('FimOrderRepository')
const CompanyRepo = RepositoryFactory.get('CompanyRepository')

export default {
  name: 'CreateOrder',
  components: {
    OrderRemarks,
    SiteAutocomplete,
    ConfirmModal
  },
  mixins: [
    userAuthGetters,
    toastMixin
  ],
  data () {
    return {
      title: '',
      splitLoad: false,
      splitLoadCount: 0,
      maxNumberOfSplitLoads: 4,
      splitLoadRegionId: null,
      splitLoadBillToId: null,
      selectedSplitLoadSite: null,
      needsToRefresh: false,
      loads: [
        {
          loadIndex: 0,
          companyId: 0,
          companyUniqueId: '',
          siteDisplay: '',
          retainDateString: '',
          retainTimeString: '',
          runoutDateString: '',
          runoutTimeString: '',
          timeZoneId: '',
          isDeleted: false,
          tanks: [],
          tankOrders: [],
          originalTanks: [],
          order: {},
          fimOrderStops: {},
          confirmErrors: []
        }
      ],
      retainDateString: '',
      retainTimeString: '',
      runoutDateString: '',
      runoutTimeString: '',
      fimOrder: {},
      // Private variables
      resolvePromise: () => {},
      sitesForSplitLoads: [],
      priorityOptions: [
        { text: 'Available', value: 'UNK' },
        { text: 'Priority', value: '1' }
      ]
    }
  },
  computed: {
    retainDateState () {
      return (index) => {
        if (this.loads[index].retainDateString.match(global.shortDateRegex)) {
          return null
        }

        return false
      }
    },
    retainTimeState () {
      return (index) => {
        if (this.loads[index].retainTimeString.match(global.time23Regex)) {
          return null
        }

        return false
      }
    },
    runoutDateState () {
      return (index) => {
        if (this.loads[index].runoutDateString.match(global.shortDateRegex)) {
          return null
        }

        return false
      }
    },
    runoutTimeState () {
      return (index) => {
        if (this.loads[index].runoutTimeString.match(global.time23Regex)) {
          return null
        }

        return false
      }
    },
    modalSize () {
      this.loads.forEach((load) => {
        if (load.tankOrders?.length > 8) {
          return 'xl'
        }
      })
      return 'lg'
    },
    siteExistsInSplitLoad () {
      return (this.selectedSplitLoadSite !== null && this.loads.some((load) => load.companyId === this.selectedSplitLoadSite.companyId))
    },
    disableAddSplitLoadBtn () {
      return this.splitLoadCount === this.maxNumberOfSplitLoads || !this.selectedSplitLoadSite || this.siteExistsInSplitLoad
    },
    addSplitLoadBtnText () {
      if (this.siteExistsInSplitLoad) {
        return 'Site already selected!'
      }
      if (this.selectedSplitLoadSite === null) {
        return 'Select a site'
      }
      const splitLoadNumber = this.splitLoadCount < this.maxNumberOfSplitLoads ? this.splitLoadCount + 1 : this.maxNumberOfSplitLoads
      return `Add Load (${splitLoadNumber} of ${this.maxNumberOfSplitLoads})`
    },
    addSplitLoadBtnColor () {
      return this.siteExistsInSplitLoad ? 'kag-red' : 'primary'
    },
    splitLoadsAllowed () {
      return global.splitLoadsAllowed(this.tenantName)
    },
    allowPONumber () {
      return global.appConfig.AllowPONumber
    }
  },
  methods: {
    gallonsGreaterThanZeroConfirm () {
      let confirm = true
      for (const load of this.loads) {
        load.confirmErrors = []
        const hasGallons = load.tankOrders.some((to) => to.gallons > 0)
        if (!hasGallons) {
          load.confirmErrors.push('Minimum of 1 gallon to be assigned, for at least 1 product at the site.')
          confirm = false
        }
      }
      return confirm
    },
    orderedGallonsSafeFillConfirm () {
      let confirm = true
      for (const load of this.loads) {
        for (const to of load.tankOrders) {
          if (to.gallons > to.safefillQty || to.gallons < 0) {
            load.confirmErrors.push(`Cannot create an order larger than tank size or safe fill, check the ${to.commodityClass} tank gallons.`)
            confirm = false
          }
        }
      }
      return confirm
    },
    isNewOrder () {
      if (this.title === 'Edit Order') return false
      let hasTankData = false
      for (const load of this.loads) {
        if (load.tanks && load.tanks.length) {
          hasTankData = true
        }
      }
      return hasTankData
    },
    getLoadRetainRunoutDate (load) {
      const retainTime = load.order.retainTime.split(':')
      const retainDateObj = {
        year: load.order.retainDate.getFullYear(),
        month: load.order.retainDate.getMonth(),
        day: load.order.retainDate.getDate(),
        hour: +retainTime[0],
        minute: +retainTime[1],
        second: +retainTime[2]
      }
      const retainDate = moment.tz(retainDateObj, load.timeZoneId)
      const runoutTime = load.order.runoutTime.split(':')
      const runoutDateObj = {
        year: load.order.runoutDate.getFullYear(),
        month: load.order.runoutDate.getMonth(),
        day: load.order.runoutDate.getDate(),
        hour: +runoutTime[0],
        minute: +runoutTime[1],
        second: +runoutTime[2]
      }
      const runoutDate = moment.tz(runoutDateObj, load.timeZoneId)
      return {
        retainDate,
        runoutDate
      }
    },
    retainRunoutDateConfirm () {
      let confirm = true
      for (const load of this.loads) {
        const loadDates = this.getLoadRetainRunoutDate(load)
        if (loadDates.runoutDate < loadDates.retainDate) {
          load.confirmErrors.push('Retain date and time cannot be greater than the Runout date and time.')
          confirm = false
        }
      }
      return confirm
    },
    getRetainRunoutDateFormatted (load) {
      const loadDates = this.getLoadRetainRunoutDate(load)
      return {
        retainDateTime: loadDates.retainDate.format('yyyy-MM-DDTHH:mm:ss'),
        runoutDateTime: loadDates.runoutDate.format('yyyy-MM-DDTHH:mm:ss')
      }
    },
    buildTanks (loadIndex) {
      this.loads[loadIndex].tankOrders = this.loads[loadIndex].tanks.map((tank) => {
        let commodityClass = tank.commodityClass
        if (this.loads[loadIndex].tanks.filter((t) => t.commodityClass === commodityClass).length > 1) {
          commodityClass += ` (${tank.tankNumber})`
        }

        return {
          commodityClass,
          commodityCode: tank.commodityCode,
          gallons: 0,
          safefillQty: tank.safefillQty,
          tankId: tank.id,
          outOfService: tank.outOfService
        }
      })
      if (loadIndex === 0) {
        const now = new Date()
        now.setDate(now.getDate() + 1)
        this.loads[loadIndex].order.retainDate = now
        this.loads[loadIndex].order.retainTime = '00:00:00'
        this.loads[loadIndex].order.runoutDate = now
        this.loads[loadIndex].order.runoutTime = '23:59:00'
        this.loads[loadIndex].retainDateString = global.buildShortDateString(now)
        this.loads[loadIndex].runoutDateString = global.buildShortDateString(now)
        this.loads[loadIndex].order.priority = 'UNK'
      } else {
        // eslint-disable-next-line no-undef
        this.loads[loadIndex].order = structuredClone(this.loads[0].order)
      }
    },
    buildFimOrders (loadIndex) {
      this.loads[loadIndex].tankOrders = this.loads[loadIndex].fimOrderStops.fimOrderProducts.map((product, index) => {
        const tankInfo = this.getTankInfo(product.tankId, loadIndex)
        return {
          id: product.id,
          commodityClass: product.commodityClass,
          commodityCode: tankInfo?.commodityCode,
          gallons: product.gallons,
          safefillQty: tankInfo?.safefillQty ?? 0,
          tankId: product.tankId,
          outOfService: tankInfo?.outOfService ?? false
        }
      })
      const retainDateTime = new Date(this.loads[loadIndex].fimOrderStops.retainDateTime)
      this.loads[loadIndex].order.retainDate = retainDateTime
      this.loads[loadIndex].order.retainTime = `${('0' + retainDateTime.getHours()).slice(-2)}:${('0' + retainDateTime.getMinutes()).slice(-2)}:00`
      const runoutDateTime = new Date(this.loads[loadIndex].fimOrderStops.runoutDateTime)
      this.loads[loadIndex].order.runoutDate = runoutDateTime
      this.loads[loadIndex].order.runoutTime = `${('0' + runoutDateTime.getHours()).slice(-2)}:${('0' + runoutDateTime.getMinutes()).slice(-2)}:00`
    },
    async show (opts = {}) {
      this.title = opts.title
      this.splitLoad = false
      this.needsToRefresh = false
      if (opts.tanks && opts.tanks.length) {
        // if new order
        this.buildLoadsForNewOrders(opts)
      } else if (opts.fimOrder) {
        // if existing order
        await this.buildLoadsForExistingOrders(opts)
      }
      this.$refs.confirmModal.show()
      return new Promise((resolve) => {
        this.resolvePromise = resolve
      })
    },
    buildLoadsForNewOrders (opts) {
      if (this.title !== 'Edit Order') {
        if (opts?.siteDisplay && opts?.siteDisplay?.length) {
          this.loads[0].siteDisplay = opts.siteDisplay
        }
      }
      this.loads[0].companyId = opts.companyId
      this.loads[0].companyUniqueId = opts.companyUniqueId
      this.loads[0].timeZoneId = opts.timeZoneId
      this.loads[0].tanks = opts.tanks
      this.splitLoadRegionId = opts.regionId
      this.splitLoadBillToId = opts.assignedBillToId
      this.buildTanks(0)
      this.splitLoadCount = 1
    },
    async buildLoadsForExistingOrders (opts) {
      this.fimOrder = opts.fimOrder
      this.loads = []
      for (let i = 0; i < opts.fimOrder.fimOrderStops.length; i++) {
        const companyInfo = opts.fimOrder.fimOrderStops[i].company
        if (i === 0) {
          this.splitLoadRegionId = companyInfo.regionId
          this.splitLoadBillToId = companyInfo.assignedBillToId
        }
        this.loads.push(
          {
            loadIndex: i,
            companyId: opts.fimOrder.fimOrderStops[i].companyId,
            companyUniqueId: companyInfo.companyUniqueId,
            siteDisplay: `${companyInfo.companyUniqueId} - ${companyInfo.companyAddressLine1}, ${companyInfo.city} ${companyInfo.state} ${companyInfo.zip}`,
            timeZoneId: companyInfo.timeZoneId,
            retainDateString: '',
            retainTimeString: '',
            runoutDateString: '',
            runoutTimeString: '',
            tanks: [],
            tankOrders: [],
            originalTanks: [],
            order: {
              customerShift: opts.fimOrder.customerShift,
              releaseNumber: opts.fimOrder.releaseNumber,
              orderRemarks: opts.fimOrder.orderRemarks,
              poNumber: opts.fimOrder.poNumber,
              priority: opts.fimOrder.priority
            },
            fimOrderStops: opts.fimOrder.fimOrderStops[i],
            confirmErrors: []
          }
        )
        await this.getTanksFromOrder(i)
      }
      this.splitLoadCount = this.loads.length
      this.splitLoad = this.splitLoadCount > 1
      this.sitesForSplitLoads = []
      await this.splitLoadToggled()
    },
    createDefaultLoad () {
      this.loads = [
        {
          loadIndex: 0,
          companyId: 0,
          companyUniqueId: '',
          siteDisplay: '',
          retainDateString: '',
          retainTimeString: '',
          runoutDateString: '',
          runoutTimeString: '',
          timeZoneId: '',
          isDeleted: false,
          tanks: [],
          tankOrders: [],
          originalTanks: [],
          order: {},
          fimOrderStops: {},
          confirmErrors: []
        }
      ]
    },
    clear () {
      this.title = ''
      this.createDefaultLoad()
      this.splitLoadCount = 1
      this.splitLoad = false
      this.selectedSplitLoadSite = null
      this.sitesForSplitLoads = []
      this.fimOrder = undefined
    },
    cancel () {
      this.clear()
      this.$refs.confirmModal.hide()
      // sending the value of needsToRefesh in case changes were made but canceled.
      // The orders will get refreshed so the data will be updated.
      this.resolvePromise(this.needsToRefresh)
    },
    async splitLoadToggled () {
      if (this.splitLoad && this.sitesForSplitLoads?.length === 0) {
        await CompanyRepo.getSites(-1, this.splitLoadRegionId, this.splitLoadBillToId)
          .then((response) => {
            const data = response && response.data ? response.data : null
            this.sitesForSplitLoads = data.sites.length > 0
              ? data.sites.map(global.mapUpperCase('companyUniqueIdAndAdress')).sort(global.sortBy('companyUniqueIdAndAdress')).map(global.mapOptions('id', 'companyUniqueIdAndAdress'))
              : []
          })
          .catch(() => {
            this.showError(`No Sites found for RegionId ${this.splitLoadRegionId} and  BillToId ${this.splitLoadBillToId}.`)
          })
      }
    },
    splitLoadSiteSelected (selectedSite) {
      this.selectedSplitLoadSite = selectedSite
    },
    async addSplitLoad () {
      let siteData = null
      await CompanyRepo.get(this.selectedSplitLoadSite.companyId)
        .then((response) => {
          siteData = response && response.data ? response.data : null
        })
        .catch(() => {
          this.showError(`No Site found for ${this.selectedSplitLoadSite.companyUniqueId}.`)
        })
        .finally(() => {
          return siteData
        })
      this.loads.push(
        {
          loadIndex: this.splitLoadCount,
          companyId: this.selectedSplitLoadSite.companyId,
          companyUniqueId: this.selectedSplitLoadSite.companyUniqueId,
          siteDisplay: this.selectedSplitLoadSite.display,
          timeZoneId: siteData.timeZoneId,
          retainDateString: this.loads[0].retainDateString,
          retainTimeString: this.loads[0].retainTimeString,
          runoutDateString: this.loads[0].runoutDateString,
          runoutTimeString: this.loads[0].runoutTimeString,
          tanks: [],
          tankOrders: [],
          originalTanks: [],
          order: {},
          fimOrderStops: undefined,
          confirmErrors: []
        }
      )
      if (siteData.tanks && siteData.tanks.length) {
        this.loads[this.splitLoadCount].tanks = [...siteData.tanks]
        this.buildTanks(this.splitLoadCount)
      }

      this.selectedSplitLoadSite = null
      this.$refs.site_autocomplete.clearValue()
      this.splitLoadCount++
    },
    onSiteAutocompleteCleared () {
      this.selectedSplitLoadSite = null
    },
    async removeSplitLoad (arrayIndex) {
      if (!this.isNewOrder()) {
        if (this.loads[arrayIndex].fimOrderStops?.id) {
          const stopRemoved = await this.confirmAndRemoveSplitLoad(arrayIndex)
          if (!stopRemoved) {
            return false
          }
        }
      }
      this.loads.splice(arrayIndex, 1)
      // reindex load index
      for (let i = 0; i < this.loads.length; i++) {
        this.loads[i].loadIndex = i
      }
      this.splitLoadCount--
    },
    async confirmAndRemoveSplitLoad (arrayIndex) {
      let stopRemoved = false
      const removeConfirmed = await this.confirmRemoveSplitLoad(arrayIndex)
      if (removeConfirmed) {
        await FimOrderRepo.removeStop(this.loads[arrayIndex].fimOrderStops?.id)
          .then(() => {
            this.showSuccess('Stop Site has ben removed.')
            this.needsToRefresh = true
            stopRemoved = true
          })
          .catch((error) => {
            this.showError(global.handleError(error, `An error occurred removing stop ${this.loads[arrayIndex].fimOrderStops?.id}`))
          })
      }
      return stopRemoved
    },
    async confirmRemoveSplitLoad (arrayIndex) {
      let result = false
      await this.$refs.removeStopConfirmModal.show({
        title: 'Remove Stop Site',
        text: `Are you sure you want to permanently remove Stop Site\n${this.loads[arrayIndex].siteDisplay}?`,
        confirmText: 'Permanently Remove',
        confirmVariant: 'outline-kag-red'
      }).then(value => {
        result = value
      }).catch(err => {
        result = false
        console.error(err)
      })
      return result
    },
    async confirm () {
      const gallonsOk = this.gallonsGreaterThanZeroConfirm()
      const safeFillOk = this.orderedGallonsSafeFillConfirm()
      const retainRunoutDatesOk = this.retainRunoutDateConfirm()
      if (!gallonsOk || !safeFillOk || !retainRunoutDatesOk) {
        this.showError('Unable to save order due to order errors.')
        return
      }
      if (this.isNewOrder()) {
        await this.createAndSendNewOrderRequest()
      } else if (this.fimOrder) { // Existing Order
        await this.updateAndSendUpdateOrderRequest()
      }
    },
    getDefaultRequestData (newOrder) {
      const defaultRequest = {
        customerShift: this.loads[0].order.customerShift,
        releaseNumber: this.loads[0].order.releaseNumber,
        orderRemarks: this.loads[0].order.orderRemarks,
        poNumber: this.loads[0].order.poNumber,
        priority: this.loads[0].order.priority,
        fimOrderStops: [],
        fimOrderProducts: []
      }
      if (newOrder) {
        defaultRequest.userName = `${this.getFirstName} ${this.getLastName}`
        defaultRequest.status = 'NEW'
        return defaultRequest
      }
      defaultRequest.id = this.fimOrder.id
      defaultRequest.userName = this.fimOrder.userName
      defaultRequest.status = this.fimOrder.status
      return defaultRequest
    },
    getStopsAndProductsForNewOrderRequest () {
      const orderStops = []
      const orderProducts = []
      for (const load of this.loads) {
        const formattedRetainRunoutDates = this.getRetainRunoutDateFormatted(load)
        orderStops.push({
          stopNumber: load.loadIndex + 1,
          companyId: load.companyId,
          retainDateTime: formattedRetainRunoutDates.retainDateTime,
          runoutDateTime: formattedRetainRunoutDates.runoutDateTime
        })
        orderProducts.push(load.tankOrders.map((to) => {
          if (!to.gallons) {
            to.gallons = 0
          }
          to.stopNumber = load.loadIndex + 1
          to.companyId = load.companyId
          return to
        }))
      }
      return { stops: orderStops, products: orderProducts.flat(1) }
    },
    async createAndSendNewOrderRequest () {
      const createRequest = this.getDefaultRequestData(true)
      const stopsAndProducts = this.getStopsAndProductsForNewOrderRequest()
      createRequest.fimOrderStops = stopsAndProducts.stops
      createRequest.fimOrderProducts = stopsAndProducts.products
      await FimOrderRepo.create(createRequest)
        .then(() => {
          this.finishOrderForm('New order has been added')
          this.$store.dispatch('orders/addOrdersToReview', createRequest)
        })
        .catch((error) => {
          this.showError(global.handleError(error, 'An error occurred while adding new order. Please try again later'))
        })
    },
    getStopsAndProductsForUpdateOrderRequest () {
      const orderStops = []
      const orderProducts = []
      for (const load of this.loads) {
        const formattedRetainRunoutDates = this.getRetainRunoutDateFormatted(load)
        const existingStop = load.fimOrderStops !== undefined
        orderStops.push({
          id: existingStop ? load.fimOrderStops.id : 0,
          fimOrderId: this.fimOrder.id,
          stopNumber: load.loadIndex + 1,
          companyId: load.companyId,
          retainDateTime: formattedRetainRunoutDates.retainDateTime,
          runoutDateTime: formattedRetainRunoutDates.runoutDateTime
        })
        orderProducts.push(load.tankOrders.map((to) => {
          if (!to.gallons) {
            to.gallons = 0
          }
          to.id = 0
          to.fimOrderId = this.fimOrder.id
          to.fimOrderStopId = 0
          if (existingStop) {
            const product = load.fimOrderStops.fimOrderProducts.find((fop) => fop.tankId === to.tankId)
            if (product !== undefined) {
              to.id = product.id
              to.fimOrderStopId = product.fimOrderStopId
            }
          }
          to.stopNumber = load.loadIndex + 1
          to.companyId = load.companyId
          return to
        }))
      }
      return { stops: orderStops, products: orderProducts.flat(1) }
    },
    async updateAndSendUpdateOrderRequest () {
      const updateRequest = this.getDefaultRequestData(false)
      const stopsAndProducts = this.getStopsAndProductsForUpdateOrderRequest()
      updateRequest.fimOrderStops = stopsAndProducts.stops
      updateRequest.fimOrderProducts = stopsAndProducts.products
      await FimOrderRepo.update(updateRequest)
        .then(() => {
          this.finishOrderForm('Order updated successfully')
          this.$store.dispatch('orders/updateOrderToReview', updateRequest)
        })
        .catch((error) => {
          this.showError(global.handleError(error, 'An error occurred while updating order. Please try again later'))
        })
    },
    onRetainDateChange (text, loadIndex) {
      if (text.match(global.sixDigitRegex)) {
        this.loads[loadIndex].retainDateString = `${text.substring(0, 2)}/${text.substring(2, 4)}/${text.substring(4, 6)}`
        this.onRetainDateChange(this.loads[loadIndex].retainDateString, loadIndex)
      } else {
        if (text.match(global.shortDateRegex)) {
          const split = text.split('/')
          this.loads[loadIndex].order.retainDate = new Date((+split[2] + 2000), +split[0] - 1, +split[1])
        }
      }
    },
    handleRetainDateKeyDown (event, loadIndex) {
      // Handle only plus and minus keys
      if (event.key === '+' || event.key === '-') {
        event.preventDefault()
        const dateValue = event.target.value
        const dayIncrement = event.key === '+' ? 1 : -1
        if (dateValue.match(global.shortDateRegex)) {
          const split = dateValue.split('/')
          const newDate = new Date((+split[2] + 2000), +split[0] - 1, +split[1])
          newDate.setDate(newDate.getDate() + dayIncrement)
          this.loads[loadIndex].order.retainDate = newDate
          this.loads[loadIndex].retainDateString = global.buildShortDateString(newDate)
        }
      }
    },
    onRetainDateContext (ctx, loadIndex) {
      this.loads[loadIndex].retainDateString = ctx.selectedDate ? `${('0' + (+ctx.selectedDate.getMonth() + 1)).slice(-2)}/${('0' + ctx.selectedDate.getDate()).slice(-2)}/${ctx.selectedDate.getFullYear().toString().substring(2, 4)}` : ''
    },
    onRetainTimeChange (text, loadIndex) {
      if (text.match(global.fourDigitRegex)) {
        this.loads[loadIndex].retainTimeString = `${text.substring(0, 2)}:${text.substring(2, 4)}`
        this.onRetainTimeChange(this.loads[loadIndex].retainTimeString, loadIndex)
      } else {
        if (text.match(global.time23Regex)) {
          const [hours, minutes] = text.split(':')
          this.loads[loadIndex].order.retainTime = `${hours}:${minutes}:00`
        }
      }
    },
    onRetainTimeContext (ctx, loadIndex) {
      this.loads[loadIndex].retainTimeString = ctx.formatted
    },
    handleRunoutDateKeyDown (event, loadIndex) {
      // Handle only plus and minus keys
      if (event.key === '+' || event.key === '-') {
        event.preventDefault()
        const dateValue = event.target.value
        const dayIncrement = event.key === '+' ? 1 : -1
        if (dateValue.match(global.shortDateRegex)) {
          const split = dateValue.split('/')
          const newDate = new Date((+split[2] + 2000), +split[0] - 1, +split[1])
          newDate.setDate(newDate.getDate() + dayIncrement)
          this.loads[loadIndex].order.runoutDate = newDate
          this.loads[loadIndex].runoutDateString = global.buildShortDateString(newDate)
        }
      }
    },
    onRunoutDateChange (text, loadIndex) {
      if (text.match(global.sixDigitRegex)) {
        this.loads[loadIndex].runoutDateString = `${text.substring(0, 2)}/${text.substring(2, 4)}/${text.substring(4, 6)}`
        this.onRunoutDateChange(this.loads[loadIndex].runoutDateString, loadIndex)
      } else {
        if (text.match(global.shortDateRegex)) {
          const split = text.split('/')
          this.loads[loadIndex].order.runoutDate = new Date((+split[2] + 2000), +split[0] - 1, +split[1])
        }
      }
    },
    onRunoutDateContext (ctx, loadIndex) {
      this.loads[loadIndex].runoutDateString = ctx.selectedDate ? `${('0' + (+ctx.selectedDate.getMonth() + 1)).slice(-2)}/${('0' + ctx.selectedDate.getDate()).slice(-2)}/${ctx.selectedDate.getFullYear().toString().substring(2, 4)}` : ''
    },
    onRunoutTimeChange (text, loadIndex) {
      if (text.match(global.fourDigitRegex)) {
        this.loads[loadIndex].runoutTimeString = `${text.substring(0, 2)}:${text.substring(2, 4)}`
        this.onRunoutTimeChange(this.loads[loadIndex].runoutTimeString, loadIndex)
      } else {
        if (text.match(global.time23Regex)) {
          const [hours, minutes] = text.split(':')
          this.loads[loadIndex].order.runoutTime = `${hours}:${minutes}:00`
        }
      }
    },
    onRunoutTimeContext (ctx, loadIndex) {
      this.loads[loadIndex].runoutTimeString = ctx.formatted
    },
    gallonsWarnState (tank) {
      return tank.gallons > tank.safefillQty || !!(tank.gallons % 1) || tank.gallons < 0
    },
    gallonsTooltipState (tank) {
      if (tank.gallons % 1) {
        return 'Gallons cannot contain decimal places'
      } else if (tank.gallons < 0) {
        return 'Gallons cannot be negative number'
      } else if (tank.gallons > tank.safefillQty) {
        return 'Gallons are greater than Safe Fill'
      } else if (tank.gallons > tank.Inventory) {
        return 'Gallons are greater than Inventory'
      }
    },
    finishOrderForm (message) {
      this.needsToRefresh = false
      this.showSuccess(message)
      this.clear()
      this.$refs.confirmModal.hide()
      this.resolvePromise(true)
      this.$emit('refresh-calculator')
    },
    getTankInfo (id, loadIndex) {
      var tankInfo = null
      this.loads[loadIndex].originalTanks.forEach((tank) => {
        if (tank.id === id) {
          tankInfo = tank
        }
      })
      return tankInfo
    },
    async getTanksFromOrder (loadIndex) {
      await TankRepo.getTanksByCompanyId(this.loads[loadIndex].companyId)
        .then((response) => {
          if (response && response.data && response.data.length) {
            this.loads[loadIndex].originalTanks = [...response.data]
          }
        })
        .catch((error) => {
          this.showError(global.handleError(error, 'An error occurred getting Tanks from order'))
        })
        .finally(() => {
          this.buildFimOrders(loadIndex)
        })
    },
    async openOrderRemarksPopUp () {
      this.$refs.orderRemarksModal.show({
        orderRemarks: this.loads[0].order.orderRemarks
      })
    },
    receiveOrderRemarks (orderRemarks) {
      this.loads[0].order.orderRemarks = orderRemarks
    }
  }
}
</script>
